module.exports = __webpack_public_path__ + "static/media/yidindji_logo.5006dde8.png";